import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-aams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-aams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { Validators } from "@angular/forms";
import { CreateApplicationDetailsAamsConstants } from "./create-application-details-aams.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import { LookupConstants } from "../../../../../shared/constants/lookup.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { phoneNumberValidator } from "../../../../../shared/classes/phone-number-validator";
import { take, takeUntil } from "rxjs/operators";
import { SimulationUtils } from "src/app/shared/utils/simulation-utils";
let CreateApplicationDetailsAamsComponent = class CreateApplicationDetailsAamsComponent extends CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    recipientSelectService;
    modalService;
    appControllerService;
    changeDetectorRefs;
    detailsForm;
    advertisementsFormGroupName = CreateApplicationDetailsAamsConstants.ADVERTISEMENTS_FORM_GROUP_NAME;
    validationMessages = CreateApplicationDetailsAamsConstants.VALIDATION_MESSAGES;
    applicationDetailsFormGroupName = CreateApplicationDetailsAamsConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    // FormControls
    descriptionFormControlName = CreateApplicationDetailsAamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    advertisementsFormControlName = CreateApplicationDetailsAamsConstants.ADVERTISEMENTS_FORM_CONTROL_NAME;
    isAdvertisementPermanentOrTemporaryFormControlName = CreateApplicationDetailsAamsConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsAamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    displayStartDateControlName = CreateApplicationDetailsAamsConstants.DISPLAY_START_DATE_FORM_CONTROL_NAME;
    displayEndDateControlName = CreateApplicationDetailsAamsConstants.DISPLAY_END_DATE_FORM_CONTROL_NAME;
    displayRemovalDateControlName = CreateApplicationDetailsAamsConstants.DISPLAY_REMOVAL_DATE_FORM_CONTROL_NAME;
    numberOfPostersControlName = CreateApplicationDetailsAamsConstants.NUMBER_OF_POSTERS_FORM_CONTROL_NAME;
    nameOfBusinessControlName = CreateApplicationDetailsAamsConstants.NAME_OF_BUSINESS_FORM_CONTROL_NAME;
    notifySignageRemovalPeriodControlName = CreateApplicationDetailsAamsConstants.NOTIFY_SIGNAGE_REMOVAL_PERIOD_FORM_CONTROL_NAME;
    positionOfTheDisplayControlName = CreateApplicationDetailsAamsConstants.POSITION_OF_DISPLAY_FORM_CONTROL_NAME;
    heightControlName = CreateApplicationDetailsAamsConstants.HEIGHT_FORM_CONTROL_NAME;
    widthControlName = CreateApplicationDetailsAamsConstants.WIDTH_FORM_CONTROL_NAME;
    depthControlName = CreateApplicationDetailsAamsConstants.DEPTH_FORM_CONTROL_NAME;
    materialControlName = CreateApplicationDetailsAamsConstants.MATERIAL_FORM_CONTROL_NAME;
    coloursControlName = CreateApplicationDetailsAamsConstants.COLOURS_FORM_CONTROL_NAME;
    frontalAreaControlName = CreateApplicationDetailsAamsConstants.FRONTAL_AREA_FORM_CONTROL_NAME;
    totalAreaControlName = CreateApplicationDetailsAamsConstants.TOTAL_AREA_FORM_CONTROL_NAME;
    signTypeControlName = CreateApplicationDetailsAamsConstants.SIGN_TYPE_FORM_CONTROL_NAME;
    weightControlName = CreateApplicationDetailsAamsConstants.WEIGHT_FORM_CONTROL_NAME;
    wattageControlName = CreateApplicationDetailsAamsConstants.WATTAGE_FORM_CONTROL_NAME;
    signContractorControlName = CreateApplicationDetailsAamsConstants.SIGN_CONTRACTOR_NAME_FORM_CONTROL_NAME;
    signContractorAddressControlName = CreateApplicationDetailsAamsConstants.SIGN_CONTRACTOR_ADDRESS_FORM_CONTROL_NAME;
    signContractorTelephoneControlName = CreateApplicationDetailsAamsConstants.SIGN_CONTRACTOR_TELEPHONE_FORM_CONTROL_NAME;
    forSaleControlName = CreateApplicationDetailsAamsConstants.FOR_SALE_FORM_CONTROL_NAME;
    onShowControlName = CreateApplicationDetailsAamsConstants.ON_SHOW_FORM_CONTROL_NAME;
    toLetControlName = CreateApplicationDetailsAamsConstants.TO_LET_FORM_CONTROL_NAME;
    soldControlName = CreateApplicationDetailsAamsConstants.SOLD_FORM_CONTROL_NAME;
    OtherControlName = CreateApplicationDetailsAamsConstants.OTHER_FORM_CONTROL_NAME;
    constructionBoardSignControlName = CreateApplicationDetailsAamsConstants.CONSTRUCTION_BOARD_SIGN_FORM_CONTROL_NAME;
    groundSignControlName = CreateApplicationDetailsAamsConstants.GROUND_SIGN_FORM_CONTROL_NAME;
    flagControlName = CreateApplicationDetailsAamsConstants.FLAG_FORM_CONTROL_NAME;
    sandwichBoardControlName = CreateApplicationDetailsAamsConstants.SANDWICH_BOARD_FORM_CONTROL_NAME;
    pylonControlName = CreateApplicationDetailsAamsConstants.PYLON_FORM_CONTROL_NAME;
    wallSignControlName = CreateApplicationDetailsAamsConstants.WALL_SIGN_FORM_CONTROL_NAME;
    billBoardControlName = CreateApplicationDetailsAamsConstants.BILLBOARD_FORM_CONTROL_NAME;
    buildingAttachmentControlName = CreateApplicationDetailsAamsConstants.BUILDING_ATTACHMENT_FORM_CONTROL_NAME;
    projectingWallControlName = CreateApplicationDetailsAamsConstants.PROJECTING_WALL_SIGN_FORM_CONTROL_NAME;
    wallPaintedControlName = CreateApplicationDetailsAamsConstants.WALL_PAINTED_FORM_CONTROL_NAME;
    roofSignControlName = CreateApplicationDetailsAamsConstants.ROOF_SIGN_FORM_CONTROL_NAME;
    skySignControlName = CreateApplicationDetailsAamsConstants.SKY_SIGN_FORM_CONTROL_NAME;
    verandaControlName = CreateApplicationDetailsAamsConstants.VERANDA_FORM_CONTROL_NAME;
    aerialSignControlName = CreateApplicationDetailsAamsConstants.AERIAL_SIGN_FORM_CONTROL_NAME;
    windowSignControlName = CreateApplicationDetailsAamsConstants.WINDOW_SIGN_FORM_CONTROL_NAME;
    schoolSignControlName = CreateApplicationDetailsAamsConstants.SCHOOL_SIGN_FORM_CONTROL_NAME;
    combinationSignControlName = CreateApplicationDetailsAamsConstants.COMBINATION_SIGN_FORM_CONTROL_NAME;
    underAwningSignControlName = CreateApplicationDetailsAamsConstants.UNDER_AWNING_SIGN_FORM_CONTROL_NAME;
    flagSignControlName = CreateApplicationDetailsAamsConstants.FLAG_SIGN_FORM_CONTROL_NAME;
    canopyControlName = CreateApplicationDetailsAamsConstants.CANOPY_FORM_CONTROL_NAME;
    balconyControlName = CreateApplicationDetailsAamsConstants.BALCONY_FORM_CONTROL_NAME;
    electronicSignControlName = CreateApplicationDetailsAamsConstants.ELECTRONIC_SIGN_FORM_CONTROL_NAME;
    developmentBoardControlName = CreateApplicationDetailsAamsConstants.DEVELOPMENT_BOARD_FORM_CONTROL_NAME;
    otherFiveYearControlName = CreateApplicationDetailsAamsConstants.OTHER_FIVE_YEAR_FORM_CONTROL_NAME;
    nonIlluminatedBillboardControlName = CreateApplicationDetailsAamsConstants.NON_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    digitalBillboardControlName = CreateApplicationDetailsAamsConstants.DIGITAL_BILLBOARD_FORM_CONTROL_NAME;
    nonIlluminatedGantryControlName = CreateApplicationDetailsAamsConstants.NON_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    digitalGantryControlName = CreateApplicationDetailsAamsConstants.DIGITAL_GANTRY_FORM_CONTROL_NAME;
    internallyIlluminatedBillboardControlName = CreateApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_BILLBOARD_FORM_CONTROL_NAME;
    internallyIlluminatedGantryControlName = CreateApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_GANTRY_FORM_CONTROL_NAME;
    municipalConsumerAccountNumberFormControlName = CreateApplicationDetailsAamsConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_CONTROL_NAME;
    personResponsibleFormControlName = CreateApplicationDetailsAamsConstants.PERSON_RESPONSIBLE_CONTROL_NAME;
    // Labels
    descriptionLabel = CreateApplicationDetailsAamsConstants.DESCRIPTION_LABEL;
    isAdvertisementPermanentOrTemporaryFormLabel = CreateApplicationDetailsAamsConstants.IS_ADVERTISEMENT_PERMANENT_OR_TEMPORARY_LABEL;
    typeLabel = CreateApplicationDetailsAamsConstants.APPLICATION_TYPE_LABEL;
    displayStartDateLabel = CreateApplicationDetailsAamsConstants.DISPLAY_START_DATE_LABEL;
    displayEndDateLabel = CreateApplicationDetailsAamsConstants.DISPLAY_END_DATE_LABEL;
    displayRemovalDateLabel = CreateApplicationDetailsAamsConstants.DISPLAY_REMOVAL_DATE_LABEL;
    numberOfPostersLabel = CreateApplicationDetailsAamsConstants.NUMBER_OF_POSTERS_LABEL;
    nameOfBusinessLabel = CreateApplicationDetailsAamsConstants.NAME_OF_BUSINESS_LABEL;
    notifySignageRemovalPeriodLabel = CreateApplicationDetailsAamsConstants.NOTIFY_SIGNAGE_REMOVAL_LABEL;
    positionOfTheDisplayLabel = CreateApplicationDetailsAamsConstants.POSITION_OF_THE_DISPLAY_LABEL;
    heightLabel = CreateApplicationDetailsAamsConstants.HEIGHT_LABEL;
    widthLabel = CreateApplicationDetailsAamsConstants.WIDTH_LABEL;
    depthLabel = CreateApplicationDetailsAamsConstants.DEPTH_LABEL;
    materialLabel = CreateApplicationDetailsAamsConstants.MATERIAL_LABEL;
    coloursLabel = CreateApplicationDetailsAamsConstants.COLOURS_LABEL;
    frontalAreaLabel = CreateApplicationDetailsAamsConstants.FRONTAL_AREA_LABEL;
    totalAreaLabel = CreateApplicationDetailsAamsConstants.TOTAL_AREA_LABEL;
    signTypeLabel = CreateApplicationDetailsAamsConstants.SIGN_TYPE_LABEL;
    weightLabel = CreateApplicationDetailsAamsConstants.WEIGHT_LABEL;
    wattageLabel = CreateApplicationDetailsAamsConstants.WATTAGE_LABEL;
    signContractorLabel = CreateApplicationDetailsAamsConstants.SIGN_CONTRACTOR_LABEL;
    signContractorAddressLabel = CreateApplicationDetailsAamsConstants.SIGN_CONTRACTOR_ADDRESS_LABEL;
    signContractorTelephoneLabel = CreateApplicationDetailsAamsConstants.SIGN_CONTRACTOR_TELEPHONE_LABEL;
    forSaleAddressLabel = CreateApplicationDetailsAamsConstants.FOR_SALE_LABEL;
    // 1 year permanent
    onShowLabel = CreateApplicationDetailsAamsConstants.ON_SHOW_LABEL;
    toLetLabel = CreateApplicationDetailsAamsConstants.TO_LET_LABEL;
    soldLabel = CreateApplicationDetailsAamsConstants.SOLD_LABEL;
    constructionBoardSignLabel = CreateApplicationDetailsAamsConstants.CONSTRUCTION_BOARD_SIGN_LABEL;
    otherLabel = CreateApplicationDetailsAamsConstants.OTHER_LABEL;
    // 5 year permanent
    groundSignLabel = CreateApplicationDetailsAamsConstants.GROUND_SIGN_FORM_LABEL;
    flagLabel = CreateApplicationDetailsAamsConstants.FLAG_FORM_LABEL;
    sandwichBoardLabel = CreateApplicationDetailsAamsConstants.SANDWICH_BOARD_FORM_LABEL;
    pylonLabel = CreateApplicationDetailsAamsConstants.PYLON_FORM_LABEL;
    wallSignLabel = CreateApplicationDetailsAamsConstants.WALL_SIGN_FORM_LABEL;
    billBoardLabel = CreateApplicationDetailsAamsConstants.BILLBOARD_FORM_LABEL;
    buildingAttachmentLabel = CreateApplicationDetailsAamsConstants.BUILDING_ATTACHMENT_LABEL;
    projectingWallLabel = CreateApplicationDetailsAamsConstants.PROJECTING_WALL_SIGN_LABEL;
    wallPaintedLabel = CreateApplicationDetailsAamsConstants.WALL_PAINTED_LABEL;
    roofSignLabel = CreateApplicationDetailsAamsConstants.ROOF_SIGN_LABEL;
    skySignLabel = CreateApplicationDetailsAamsConstants.SKY_SIGN_LABEL;
    verandaLabel = CreateApplicationDetailsAamsConstants.VERANDA_LABEL;
    aerialSignLabel = CreateApplicationDetailsAamsConstants.AERIAL_SIGN_LABEL;
    windowSignLabel = CreateApplicationDetailsAamsConstants.WINDOW_SIGN_LABEL;
    schoolSignLabel = CreateApplicationDetailsAamsConstants.SCHOOL_SIGN_LABEL;
    combinationSignLabel = CreateApplicationDetailsAamsConstants.COMBINATION_SIGN_LABEL;
    underAwningSignLabel = CreateApplicationDetailsAamsConstants.UNDER_AWNING_SIGN_LABEL;
    flagSignLabel = CreateApplicationDetailsAamsConstants.FLAG_SIGN_LABEL;
    canopyLabel = CreateApplicationDetailsAamsConstants.CANOPY_LABEL;
    balconyLabel = CreateApplicationDetailsAamsConstants.BALCONY_LABEL;
    electronicSignLabel = CreateApplicationDetailsAamsConstants.ELECTRONIC_SIGN_LABEL;
    developmentBoardLabel = CreateApplicationDetailsAamsConstants.DEVELOPMENT_BOARD_LABEL;
    otherFiveYearLabel = CreateApplicationDetailsAamsConstants.OTHER_FIVE_YEAR_LABEL;
    nonIlluminatedBillboardLabel = CreateApplicationDetailsAamsConstants.NON_ILLUMINATED_BILLBOARD_LABEL;
    digitalBillboardLabel = CreateApplicationDetailsAamsConstants.DIGITAL_BILLBOARD_LABEL;
    nonIlluminatedGantryLabel = CreateApplicationDetailsAamsConstants.NON_ILLUMINATED_GANTRY_LABEL;
    digitalGantryLabel = CreateApplicationDetailsAamsConstants.DIGITAL_GANTRY_LABEL;
    internallyIlluminatedBillboardLabel = CreateApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LABEL;
    internallyIlluminatedGantryLabel = CreateApplicationDetailsAamsConstants.INTERNALLY_ILLUMINATED_GANTRY_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    municipalConsumerAccountNumberLabel = CreateApplicationDetailsAamsConstants.MUNICIPAL_CONSUMER_ACCOUNT_NUMBER_LABEL;
    personResponsibleLabel = CreateApplicationDetailsAamsConstants.PERSON_RESPONSIBLE_CONTROL_LABEL;
    // Lookups
    applicationTypesLookups = [];
    permanentOrTemporaryLookupOptions = LookupConstants.PERMANENT_OR_TEMPORARY_LOOKUPS_A;
    signTypeLookups = [];
    removalPeriodLookups = LookupConstants.REMOVAL_PERIOD_LOOKUPS_A;
    nonIlluminatedBillboardLookups = LookupConstants.NON_ILLUMINATED_BILLBOARD_A;
    nonIlluminatedGantryLookups = LookupConstants.NON_ILLUMINATED_GANTRY_A;
    internallyIlluminatedBillboardLookups = LookupConstants.INTERNALLY_ILLUMINATED_BILLBOARD_LOOKUPS_A;
    digitalGantryLookups = LookupConstants.DIGITAL_GANTRY_A;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    showTemporaryApplicationFields = false;
    showPermanentApplicationFields = false;
    showApplicationType = false;
    show5YearPermanentApplicationOptionalFields = false;
    show1YearPermanentApplicationOptionalFields = false;
    // person responsible recipient
    personResponsibleDisableAdd = true;
    personResponsibleDisableEditing = false;
    personResponsibleDisableFilterBy = true;
    personResponsibleIsInternal = false;
    personResponsibleGroups = [];
    personResponsibleShowFields = true;
    applicationTypesLookupOptions = [];
    getLookupsObservableSubscription;
    constructor(createApplicationService, aflaModuleStrategyService, recipientSelectService, modalService, appControllerService, changeDetectorRefs) {
        super(createApplicationService, aflaModuleStrategyService);
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientSelectService = recipientSelectService;
        this.modalService = modalService;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        if (this.appControllerService.moduleSimulateMode) {
            const defaults = SimulationUtils.simulate_Create_Application();
            this.personResponsibleGroups = this.recipientSelectService.checkStepMetaRecipientGroups(SimulationUtils.simulateRecipientFilterGroupObjects);
            this.applicationTypesLookupOptions = defaults.advertisingApplicationType;
            this.applicationTypesLookups = defaults.advertisingApplicationType;
            this.signTypeLookups = defaults.signType;
            this.checkIfFormWasPreviouslyCompleted();
        }
        else {
            if (this.aflaModuleStrategyService.lookups.has(this.applicationTypeFormControlName) && this.aflaModuleStrategyService.lookups.has(this.signTypeControlName)) {
                this.applicationTypesLookups = this.aflaModuleStrategyService.lookups.get(this.applicationTypeFormControlName);
                this.signTypeLookups = this.aflaModuleStrategyService.lookups.get(this.signTypeControlName);
                this.checkIfFormWasPreviouslyCompleted();
            }
            else {
                this.getLookups();
            }
            this.getMetadata();
            this.checkIfFormWasPreviouslyCompleted();
        }
        this.changeDetectorRefs.detectChanges();
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    loadMetadata(stepMeta) {
        try {
            this.personResponsibleGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.personResponsibleGroup);
            this.changeDetectorRefs.detectChanges();
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    onPermanentOrTemporaryAdvertisementSelected($event) {
        const advertisementType = $event.target.value;
        const isAdvertisementControl = this.detailsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName);
        const propertiesFormArray = this.aflaModuleStrategyService.form.get(this.advertisementsFormGroupName).get(this.advertisementsFormControlName);
        if (propertiesFormArray.length > 0) {
            this.confirmChangeFromUser(advertisementType, isAdvertisementControl);
        }
        else {
            this.handleAdvertisementTypeValueChanged(advertisementType);
        }
    }
    onApplicationTypeSelected($event) {
        const selectedApplicationType = $event.target.value;
        const advertisementType = this.detailsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).value;
        if (advertisementType?.toLowerCase() === "permanent") {
            this.onPermanentApplicationTypeSelected(selectedApplicationType);
        }
        if (advertisementType?.toLowerCase() === "temporary") {
            this.onTemporaryApplicationTypeSelected();
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.createApplicationService.moduleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.createApplicationService.getLookupsObservable(params)
            .pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsAamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypesLookups.push(lookUpContent);
            }
            if (lookUp.name?.toLowerCase()?.trim() === "signtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.signTypeLookups.push(lookUpContent);
            }
        });
        this.aflaModuleStrategyService.lookups.set(this.applicationTypeFormControlName, this.applicationTypesLookups);
        this.aflaModuleStrategyService.lookups.set(this.signTypeControlName, this.signTypeLookups);
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
    }
    showTemporaryApplicationTypeFields() {
        this.showTemporaryApplicationFields = true;
    }
    showPermanentAdvertisementFields() {
        this.showPermanentApplicationFields = true;
    }
    showApplicationTypeField() {
        this.showApplicationType = true;
    }
    hideTemporaryAdvertisementFields() {
        this.showTemporaryApplicationFields = false;
    }
    clearTemporaryAdvertisementFieldsValidators() {
        this.detailsForm.get(this.displayStartDateControlName).clearValidators();
        this.detailsForm.get(this.displayEndDateControlName).clearValidators();
        this.detailsForm.get(this.displayRemovalDateControlName).clearValidators();
        this.detailsForm.get(this.numberOfPostersControlName).clearValidators();
        this.detailsForm.updateValueAndValidity();
    }
    resetTemporaryAdvertisementFields() {
        this.detailsForm.get(this.displayStartDateControlName).reset();
        this.detailsForm.get(this.displayEndDateControlName).reset();
        this.detailsForm.get(this.displayRemovalDateControlName).reset();
        this.detailsForm.get(this.numberOfPostersControlName).reset(0);
        this.detailsForm.updateValueAndValidity();
    }
    addValidatorsToMainPermanentFields() {
        // adds validators to fields that are common to 5 year and 1 year permanent fields
        this.detailsForm.get(this.nameOfBusinessControlName).addValidators(Validators.required);
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).addValidators(Validators.required);
        this.detailsForm.get(this.positionOfTheDisplayControlName).addValidators(Validators.required);
        this.detailsForm.get(this.heightControlName).addValidators(Validators.required);
        this.detailsForm.get(this.widthControlName).addValidators(Validators.required);
        this.detailsForm.get(this.depthControlName).addValidators(Validators.required);
        this.detailsForm.get(this.materialControlName).addValidators(Validators.required);
        this.detailsForm.get(this.coloursControlName).addValidators(Validators.required);
        this.detailsForm.get(this.frontalAreaControlName).addValidators(Validators.required);
        this.detailsForm.get(this.totalAreaControlName).addValidators(Validators.required);
        this.detailsForm.get(this.signTypeControlName).addValidators(Validators.required);
        this.detailsForm.get(this.weightControlName).addValidators(Validators.required);
        this.detailsForm.get(this.wattageControlName).addValidators(Validators.required);
        this.detailsForm.get(this.signContractorTelephoneControlName).addValidators(phoneNumberValidator);
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).addValidators(Validators.required);
        this.detailsForm.updateValueAndValidity();
    }
    reset5YearPermanentApplicationFields() {
        this.detailsForm.get(this.groundSignControlName).reset(false);
        this.detailsForm.get(this.flagControlName).reset(false);
        this.detailsForm.get(this.sandwichBoardControlName).reset(false);
        this.detailsForm.get(this.pylonControlName).reset(false);
        this.detailsForm.get(this.wallSignControlName).reset(false);
        this.detailsForm.get(this.billBoardControlName).reset(false);
        this.detailsForm.get(this.buildingAttachmentControlName).reset(false);
        this.detailsForm.get(this.projectingWallControlName).reset(false);
        this.detailsForm.get(this.wallPaintedControlName).reset(false);
        this.detailsForm.get(this.roofSignControlName).reset(false);
        this.detailsForm.get(this.skySignControlName).reset(false);
        this.detailsForm.get(this.verandaControlName).reset(false);
        this.detailsForm.get(this.aerialSignControlName).reset(false);
        this.detailsForm.get(this.windowSignControlName).reset(false);
        this.detailsForm.get(this.schoolSignControlName).reset(false);
        this.detailsForm.get(this.combinationSignControlName).reset(false);
        this.detailsForm.get(this.underAwningSignControlName).reset(false);
        this.detailsForm.get(this.flagSignControlName).reset(false);
        this.detailsForm.get(this.canopyControlName).reset(false);
        this.detailsForm.get(this.balconyControlName).reset(false);
        this.detailsForm.get(this.electronicSignControlName).reset(false);
        this.detailsForm.get(this.developmentBoardControlName).reset(false);
        this.detailsForm.get(this.otherFiveYearControlName).reset();
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).reset();
        this.detailsForm.get(this.digitalBillboardControlName).reset();
        this.detailsForm.get(this.nonIlluminatedGantryControlName).reset();
        this.detailsForm.get(this.digitalGantryControlName).reset();
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).reset();
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    add5YearApplicationFieldsValidators() {
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).addValidators(Validators.required);
        this.detailsForm.get(this.digitalBillboardControlName).addValidators(Validators.required);
        this.detailsForm.get(this.nonIlluminatedGantryControlName).addValidators(Validators.required);
        this.detailsForm.get(this.digitalGantryControlName).addValidators(Validators.required);
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).addValidators(Validators.required);
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).addValidators(Validators.required);
        this.detailsForm.updateValueAndValidity();
    }
    clearValidatorsOn5YearPermanentApplicationFields() {
        this.detailsForm.get(this.nonIlluminatedBillboardControlName).clearValidators();
        this.detailsForm.get(this.digitalBillboardControlName).clearValidators();
        this.detailsForm.get(this.nonIlluminatedGantryControlName).clearValidators();
        this.detailsForm.get(this.digitalGantryControlName).clearValidators();
        this.detailsForm.get(this.internallyIlluminatedBillboardControlName).clearValidators();
        this.detailsForm.get(this.internallyIlluminatedGantryControlName).clearValidators();
        this.detailsForm.updateValueAndValidity();
    }
    reset1yearPermanentApplicationFields() {
        this.detailsForm.get(this.forSaleControlName).reset(false);
        this.detailsForm.get(this.onShowControlName).reset(false);
        this.detailsForm.get(this.toLetControlName).reset(false);
        this.detailsForm.get(this.soldControlName).reset(false);
        this.detailsForm.get(this.constructionBoardSignControlName).reset(false);
        this.detailsForm.get(this.OtherControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    clearMainPermanentFieldsValidators() {
        this.detailsForm.get(this.nameOfBusinessControlName).clearValidators();
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).clearValidators();
        this.detailsForm.get(this.positionOfTheDisplayControlName).clearValidators();
        this.detailsForm.get(this.heightControlName).clearValidators();
        this.detailsForm.get(this.widthControlName).clearValidators();
        this.detailsForm.get(this.depthControlName).clearValidators();
        this.detailsForm.get(this.materialControlName).clearValidators();
        this.detailsForm.get(this.coloursControlName).clearValidators();
        this.detailsForm.get(this.frontalAreaControlName).clearValidators();
        this.detailsForm.get(this.totalAreaControlName).clearValidators();
        this.detailsForm.get(this.signTypeControlName).clearValidators();
        this.detailsForm.get(this.weightControlName).clearValidators();
        this.detailsForm.get(this.wattageControlName).clearValidators();
        this.detailsForm.get(this.signContractorControlName).clearValidators();
        this.detailsForm.get(this.signContractorAddressControlName).clearValidators();
        this.detailsForm.get(this.signContractorTelephoneControlName).clearValidators();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).clearValidators();
        this.detailsForm.updateValueAndValidity();
    }
    resetMainPermanentFields() {
        this.detailsForm.get(this.nameOfBusinessControlName).reset();
        this.detailsForm.get(this.notifySignageRemovalPeriodControlName).reset();
        this.detailsForm.get(this.positionOfTheDisplayControlName).reset();
        this.detailsForm.get(this.heightControlName).reset(0);
        this.detailsForm.get(this.widthControlName).reset(0);
        this.detailsForm.get(this.depthControlName).reset(0);
        this.detailsForm.get(this.materialControlName).reset();
        this.detailsForm.get(this.coloursControlName).reset();
        this.detailsForm.get(this.frontalAreaControlName).reset(0);
        this.detailsForm.get(this.totalAreaControlName).reset(0);
        this.detailsForm.get(this.signTypeControlName).reset();
        this.detailsForm.get(this.weightControlName).reset(0);
        this.detailsForm.get(this.wattageControlName).reset(0);
        this.detailsForm.get(this.signContractorControlName).reset();
        this.detailsForm.get(this.signContractorAddressControlName).reset();
        this.detailsForm.get(this.signContractorTelephoneControlName).reset();
        this.detailsForm.get(this.municipalConsumerAccountNumberFormControlName).reset();
        this.detailsForm.updateValueAndValidity();
    }
    filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementType) {
        if (advertisementType.toLowerCase() === "temporary") {
            this.applicationTypesLookupOptions = [];
            this.applicationTypesLookups.forEach((applicationType) => {
                if (applicationType.value.toLowerCase().includes(advertisementType))
                    this.applicationTypesLookupOptions.push(applicationType);
            });
            this.applicationTypesLookupOptions.sort((a, b) => {
                return a.value > b.value ? 1 : -1;
            });
        }
        if (advertisementType.toLowerCase() === "permanent") {
            this.applicationTypesLookupOptions = [];
            this.applicationTypesLookups.forEach((applicationType) => {
                if (applicationType.value.toLowerCase().includes(advertisementType))
                    this.applicationTypesLookupOptions.push(applicationType);
            });
            this.applicationTypesLookupOptions.sort((a, b) => {
                return a.value > b.value ? 1 : -1;
            });
        }
    }
    resetApplicationTypeField() {
        this.detailsForm.get(this.applicationTypeFormControlName).reset();
    }
    checkIfFormWasPreviouslyCompleted() {
        if (this.detailsForm.dirty && this.detailsForm.touched) {
            const advertisementTypeValue = this.detailsForm.get(this.isAdvertisementPermanentOrTemporaryFormControlName).value;
            const applicationType = this.detailsForm.get(this.applicationTypeFormControlName).value;
            if (advertisementTypeValue) {
                this.showApplicationTypeField();
                this.filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementTypeValue);
            }
            if (advertisementTypeValue && applicationType) {
                if (advertisementTypeValue === "permanent") {
                    this.setupDefaultFormsForPermanentAdvertisementApplications();
                    if (applicationType.toLowerCase().includes("1 year")) {
                        this.setupDefaultFormsFor1YearPermanentAdvertisementApplications();
                    }
                    if (applicationType.toLowerCase().includes("5 year")) {
                        this.setupDefaultFormsFor5YearPermanentAdvertisementApplications();
                    }
                }
                if (advertisementTypeValue === "temporary") {
                    this.setupDefaultFormsForTemporaryAdvertisementApplications();
                }
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    resetLocationDetails() {
        const propertiesFormArray = this.aflaModuleStrategyService.form.get("propertiesForm").get("properties");
        propertiesFormArray.clear();
    }
    handleAdvertisementTypeValueChanged(advertisementType) {
        this.showApplicationTypeField();
        this.filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementType);
        this.resetApplicationTypeField();
        this.changeDetectorRefs.detectChanges();
    }
    confirmChangeFromUser(advertisementType, isAdvertisementControl) {
        const dialogRef = this.modalService.open(PopUpComponent, CreateApplicationDetailsAamsConstants.MODAL_OPTIONS);
        dialogRef.componentInstance.title = CreateApplicationDetailsAamsConstants.MODAL_DIALOG_TITLE;
        dialogRef.componentInstance.contentMessage = CreateApplicationDetailsAamsConstants.MODAL_DIALOG_MESSAGE;
        dialogRef.componentInstance.data = true;
        dialogRef.result.then((canContinueMakingChanges) => {
            if (canContinueMakingChanges) {
                this.resetLocationAndApplicationDetails();
                this.filterApplicationTypeAccordingToSelectedAdvertisementType(advertisementType);
            }
            else {
                advertisementType.toLowerCase() === "temporary" ? isAdvertisementControl.setValue("permanent") : isAdvertisementControl.setValue("temporary");
            }
        });
    }
    addValidatorsToTemporaryFields() {
        this.detailsForm.get(this.displayStartDateControlName).addValidators(Validators.required);
        this.detailsForm.get(this.displayEndDateControlName).addValidators(Validators.required);
        this.detailsForm.get(this.displayRemovalDateControlName).addValidators(Validators.required);
        this.detailsForm.get(this.numberOfPostersControlName).addValidators(Validators.required);
        this.detailsForm.updateValueAndValidity();
    }
    onPermanentApplicationTypeSelected(selectedApplicationType) {
        this.resetAndHideTemporaryApplicationTypeFields();
        this.showPermanentAdvertisementFields();
        this.addValidatorsToMainPermanentFields();
        if (selectedApplicationType.toLowerCase().includes("5 year")) {
            this.reset1yearPermanentApplicationFields();
            this.hide1YearPermanentApplicationFields();
            this.show5YearPermanentApplicationFields();
            this.reset5YearPermanentApplicationFields();
            this.add5YearApplicationFieldsValidators();
        }
        if (selectedApplicationType.toLowerCase().includes("1 year")) {
            this.reset5YearPermanentApplicationFields();
            this.clearValidatorsOn5YearPermanentApplicationFields();
            this.hide5YearPermanentApplicationFields();
            this.show1YearPermanentApplicationFields();
            this.reset1yearPermanentApplicationFields();
        }
    }
    onTemporaryApplicationTypeSelected() {
        this.resetAndHidePermanentTypeFields();
        this.showTemporaryApplicationTypeFields();
        this.addValidatorsToTemporaryFields();
    }
    resetAndHidePermanentTypeFields() {
        // reset and hide 1 year permanent fields
        this.reset1yearPermanentApplicationFields();
        this.hide1YearPermanentApplicationFields();
        // reset and hide 5 year permanent fields
        this.clearValidatorsOn5YearPermanentApplicationFields();
        this.reset5YearPermanentApplicationFields();
        this.hide5YearPermanentApplicationFields();
        // reset and hide fields that are common in 5 year and 1 year permanent fields
        this.clearMainPermanentFieldsValidators();
        this.resetMainPermanentFields();
        this.hideMainPermanentFields();
    }
    hide1YearPermanentApplicationFields() {
        this.show1YearPermanentApplicationOptionalFields = false;
    }
    show1YearPermanentApplicationFields() {
        this.show1YearPermanentApplicationOptionalFields = true;
    }
    hide5YearPermanentApplicationFields() {
        this.show5YearPermanentApplicationOptionalFields = false;
    }
    show5YearPermanentApplicationFields() {
        this.show5YearPermanentApplicationOptionalFields = true;
    }
    hideMainPermanentFields() {
        this.showPermanentApplicationFields = false;
    }
    resetAndHideTemporaryApplicationTypeFields() {
        // reset and hide temporary fields
        this.resetTemporaryAdvertisementFields();
        this.clearTemporaryAdvertisementFieldsValidators();
        this.hideTemporaryAdvertisementFields();
    }
    hideApplicationTypeField() {
        this.showApplicationType = false;
    }
    resetLocationAndApplicationDetails() {
        this.resetLocationDetails();
        this.reset1yearPermanentApplicationFields();
        this.hide1YearPermanentApplicationFields();
        this.reset5YearPermanentApplicationFields();
        this.clearValidatorsOn5YearPermanentApplicationFields();
        this.hide5YearPermanentApplicationFields();
        this.resetMainPermanentFields();
        this.clearMainPermanentFieldsValidators();
        this.hideMainPermanentFields();
        this.resetTemporaryAdvertisementFields();
        this.clearTemporaryAdvertisementFieldsValidators();
        this.hideTemporaryAdvertisementFields();
        this.resetApplicationTypeField();
        this.hideApplicationTypeField();
    }
    setNumberToDecimal(control, event, decimalPlace) {
        const value = event.target.value;
        const decimalString = parseFloat(value).toFixed(decimalPlace);
        const decimalValue = parseFloat(decimalString);
        control.setValue(decimalValue);
    }
    setupDefaultFormsForPermanentAdvertisementApplications() {
        this.resetTemporaryAdvertisementFields();
        this.clearTemporaryAdvertisementFieldsValidators();
        this.hideTemporaryAdvertisementFields();
        this.showPermanentAdvertisementFields();
    }
    setupDefaultFormsFor1YearPermanentAdvertisementApplications() {
        this.reset5YearPermanentApplicationFields();
        this.clearValidatorsOn5YearPermanentApplicationFields();
        this.hide5YearPermanentApplicationFields();
        this.show1YearPermanentApplicationFields();
    }
    setupDefaultFormsFor5YearPermanentAdvertisementApplications() {
        this.reset1yearPermanentApplicationFields();
        this.hide1YearPermanentApplicationFields();
        this.show5YearPermanentApplicationFields();
        this.add5YearApplicationFieldsValidators();
    }
    setupDefaultFormsForTemporaryAdvertisementApplications() {
        this.resetAndHidePermanentTypeFields();
        this.showTemporaryApplicationTypeFields();
        this.addValidatorsToTemporaryFields();
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: RecipientSelectService },
        { type: NgbModal },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsAamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-aams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsAamsComponent);
export { CreateApplicationDetailsAamsComponent };
